import React from "react";
import { Box, Button, Typography, Paper, useTheme } from "@material-ui/core";
import { Icon } from "@iconify/react";
import AddIcon from "@material-ui/icons/Add";
import ProductListItem from "./ProductListItem";
import { CustomTheme } from "../../../../../../types/customTheme";

interface ProductsSectionProps {
  selectedProduct: any[];
  expandedProductIds: Set<string | number>;
  onExpandToggle: (id: string | number) => void;
  stockDepartmentSelectedNode: any[];
  selectedDepartmentObj: any;
  onDepartmentChange: (dept: any, productId: string) => void;
  classes: any;
  calculateMargin: (price: number, cost: number) => string;
  onProductFieldChange: (field: string, value: any, productId: string) => void;
  onImmediateProductValidToggle?: (productId: string, checked: boolean, product: any) => void;
  isEditDisabled: boolean
}

const ProductsSection: React.FC<ProductsSectionProps> = ({
  selectedProduct,
  expandedProductIds,
  onExpandToggle,
  stockDepartmentSelectedNode,
  selectedDepartmentObj,
  onDepartmentChange,
  classes,
  calculateMargin,
  onProductFieldChange,
  onImmediateProductValidToggle,isEditDisabled
}) => {
  const theme: CustomTheme = useTheme();
  return (
    <Paper
      elevation={0}
      style={{
        marginBottom: 24,
        borderRadius: 16,
        backgroundColor: theme.palette.background.menuProductColor,
        padding: 24,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Box display="flex" alignItems="center">
          <Box
            style={{
              backgroundColor: "#5e35b1",
              borderRadius: 8,
              padding: 6,
              marginRight: 12,
            }}
          >
            <Icon icon="lucide:layers" width="20" style={{ color: "white" }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold" }}
              align="left"
            >
              Products ({selectedProduct?.length || 0})
            </Typography>
            <Typography variant="caption">
              Manage products under this wrapper.
            </Typography>
          </Box>
        </Box>
        <Button
          startIcon={<AddIcon style={{ color: "white" }} />}
          style={{
            backgroundColor: "#5e35b1",
            textTransform: "none",
            borderRadius: "8px",
            padding: "6px 16px",
            color: "white",
          }}
          disabled={isEditDisabled}
        >
          Add Product
        </Button>
      </Box>
      {console.log("dfsdfgsdggdfg", selectedProduct)}
      {selectedProduct.map((product, index) => {
        const isExpanded = expandedProductIds.has(product.id || index);

        return (
          <ProductListItem
            key={product.id || index}
            product={product}
            index={index}
            isExpanded={isExpanded}
            isLastItem={index === selectedProduct.length - 1}
            onExpandToggle={onExpandToggle}
            stockDepartmentSelectedNode={stockDepartmentSelectedNode}
            selectedDepartmentObj={selectedDepartmentObj}
            onDepartmentChange={onDepartmentChange}
            classes={classes}
            calculateMargin={calculateMargin}
            onFieldChange={onProductFieldChange}
            onImmediateValidToggle={onImmediateProductValidToggle}
          />
        );
      })}
    </Paper>
  );
};

export default ProductsSection;